/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const conversionFlowNodes = Array.from(document.querySelectorAll('.conversion-flow'));
if (conversionFlowNodes.length) {
    import(/* webpackChunkName: "ConversionFlow" */ './components/ConversionFlow').then(({ default: ConversionFlow }) => {
        conversionFlowNodes.forEach((node) => render(<ConversionFlow {...parseDataToProps(node.dataset)} />, node));
    });
}
